var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.916 0.00250244H8.07898C3.61453 0.00250244 0 3.61703 0 8.08149V31.9235C0 36.383 3.61453 39.9975 8.07898 39.9975H31.921C36.3805 39.9975 40 36.383 40 31.9185V8.08149C39.995 3.61703 36.3805 0.00250244 31.916 0.00250244Z",
    fill: "url(#paint0_linear_81_491)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8275 9.19133L20.6374 7.79149C21.1373 6.91657 22.2522 6.62164 23.1271 7.12157C24.002 7.62149 24.2969 8.73633 23.797 9.61125L15.9929 23.1196H21.6372C23.467 23.1196 24.4918 25.2694 23.697 26.7591H7.14911C6.13927 26.7591 5.32935 25.9492 5.32935 24.9394C5.32935 23.9295 6.13927 23.1196 7.14911 23.1196H11.7886L17.7279 12.8259L15.8731 9.60625C15.3732 8.73133 15.6681 7.62649 16.543 7.11657C17.4179 6.61664 18.5228 6.91157 19.0327 7.78649L19.8275 9.19133ZM12.8084 28.6339L11.0586 31.6685C10.5587 32.5434 9.44388 32.8384 8.56895 32.3384C7.69403 31.8385 7.39911 30.7237 7.89903 29.8488L9.19888 27.5991C10.6686 27.1441 11.8635 27.4941 12.8084 28.6339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8765 23.1296H32.6109C33.6207 23.1296 34.4306 23.9395 34.4306 24.9494C34.4306 25.9592 33.6207 26.7691 32.6109 26.7691H29.9812L31.7559 29.8487C32.2559 30.7237 31.9609 31.8285 31.086 32.3384C30.2111 32.8384 29.1062 32.5434 28.5963 31.6685C25.6067 26.4841 23.3619 22.6047 21.8722 20.02C20.3473 17.3903 21.4373 14.7506 22.5121 13.8558C23.707 15.9055 25.4918 19.0001 27.8765 23.1296Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_81_491",
    x1: 20,
    y1: 0.00250244,
    x2: 20,
    y2: 39.9975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0073F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/appStore.53782922c0c013a3267c869bcd943cb7.svg";
export { ForwardRef as ReactComponent };